import {createSelector, createSlice, current} from '@reduxjs/toolkit'
import {apiCore, apiCoreV2} from "../apiSlice/apiCore";

const userAuthStatusApi = apiCore
    .injectEndpoints({
        endpoints: (build) => ({
            getUserAuthStatus: build.query({
                providesTags: ['get-user-auth-status'],
                query: () => '/status/',
                transformResponse: (response) => response ?? []
            }),
            chooseCreditPlan: build.mutation({
                invalidatesTags: ['get-user-auth-status'],
                query: (arg) => ({
                    url: 'https://accredit.kalamarket.com/api/v2/choose-credit-plans/',
                    method: "POST",
                    body: {
                        plan: arg?.planId,
                    }
                })
            }),
        })
    })

const userGetPrefilledDetails = apiCoreV2
    .injectEndpoints({
        endpoints: (build) => ({
            getPrefilledDetails: build.query({
                providesTags: ['fetch-prefilled-details'],
                query: () => '/details',
            }),
            setUserDetails: build.mutation({
                query: (userData) => ({
                    url: '/details',
                    method: "POST",
                    body: userData
                }),
            }),
        }),
    })

export const {useGetUserAuthStatusQuery,useChooseCreditPlanMutation} = userAuthStatusApi;
export const {useGetPrefilledDetailsQuery,useSetUserDetailsMutation} = userGetPrefilledDetails;


const userSlice = createSlice({
    name: 'userSlice',
    initialState: {
        user: {
            data: {},
        },
        stepStatus: {
            isAllow: false,
            navigateUrl: "",
            editing: false
        },
        steps: [
            // {step: 'register', pathname: '/'},
            {step: 'register', pathname: '/facility-selection'},
            {step: 'accredit-plan', pathname: '/completion-information'},
            {step: 'details', pathname: '/completion-information'},
            {step: 'accredit-payment', pathname: '/request-inquiry'},
            {step: 'accredit-otp-sent', pathname: '/request-inquiry'},
            {step: 'accredit-assessment', pathname: '/credit-score-inquiry'},
            {step: 'mellat', pathname: '/credit-score-inquiry'},
            // {step: 'bank-inquiry', pathname: '/check-bank-account'},
            {step: 'bank-inquiry-failed', pathname: '/bank-error'},
            {step: 'safarmarket', pathname: '/credit-score-calculation'},
            {step: 'safarmarket', pathname: '/facility-selection'},
            {step: 'docs', pathname: '/upload-documents'},
            {step: 'accredit', pathname: '/upload-documents'},
            // {step: 'docs_approved', pathname: '/delivery-guarantee-check'},
            {step: 'docs_approved', pathname: '/upload-documents'},
            {step: 'cheque-delivery', pathname: '/delivery-remaining-time'},
            {step: 'cheque-delivery-success', pathname: '/delivery-guarantee-check-success'},
            {step: 'cheque-delivery-failed', pathname: '/delivery-guarantee-check-fail'},
            // {step: 'biometrics-done', pathname: '/credit-score-calculation'},
            // {step: 'service-payment', pathname: ''},
            // {step: 'signed', pathname: ''},
            // {step: 'rejected', pathname: '/deposit-to-wallet-failed'},
            {step: 'approve', pathname: '/deposit-to-wallet-succeed'}
        ],
    },
    reducers: {
        checkUserStep: (state, action) => {
            const userData = state.user
            const mustBeStep = state?.steps?.find(status => status.step === userData?.data?.data?.user?.status)
            if (!mustBeStep) return;
            if(userData?.data?.data?.user?.status === "register" && action?.payload?.currentPathName === "/") {
                state.stepStatus = {...state.stepStatus, isAllow: true}
            }else if (userData?.data?.data?.user?.status === "safarmarket" && action?.payload?.currentPathName === "/facility-selection") {
                state.stepStatus = {...state.stepStatus, isAllow: true, editing: true}
            } else if (mustBeStep.pathname === action?.payload?.currentPathName) {
                state.stepStatus = {...state.stepStatus, isAllow: true}
            } else {
                state.stepStatus = {...state.stepStatus, isAllow: false, navigateUrl: mustBeStep?.pathname}
            }
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(userAuthStatusApi.endpoints.getUserAuthStatus.matchFulfilled, (state, {payload}) => {
            state.user.data = payload;
        })
    },
})

export const useUser = createSelector(
    (state) => state.userSlice?.user,
    (user) => user.data
)

export const useUserStep = (state) => state.userSlice?.stepStatus;

export const {checkUserStep} = userSlice.actions
export default userSlice.reducer